import React, { FC } from "react";
import { StaticImage } from "gatsby-plugin-image";
import cn from "classnames";
import "./tickCrossList.scss";
import { Typography } from "@trussle/external-components";

export interface ITickCrossItem {
    text: string;
    type: "tick" | "cross";
}
export interface ITickCrossListProps {
    tickCrossList?: ITickCrossItem[];
    className: string;
}
export const TickCrossList: FC<ITickCrossListProps> = ({ tickCrossList, className }) => (tickCrossList ? (
  <ul className={cn(className, "tickCrossList__list")}>
    {tickCrossList.map(({ text, type }) => (
      <li className="tickCrossList__item">
        {type === "tick"
          ? <StaticImage src="../../../../static/tickCircle.svg" alt="Tick" className="tickCrossList__image" />
          : <StaticImage src="../../../../static/crossCircle.svg" alt="Cross" className="tickCrossList__image" />}
        <Typography classes="tickCrossList__text" variant="h7">{text}</Typography>
      </li>
    ))}
  </ul>
) : null);
